import React from "react";
import { Card, CardContent, Stack, Avatar, Typography } from "@mui/material";
import CreditScoreIcon from "@mui/icons-material/CreditScore";

export const SummaryStatCard = ({ label, value }) => {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar>
            <CreditScoreIcon />
          </Avatar>
          <Stack>
            <Typography variant="h6">{value}</Typography>
            <Typography variant="caption" color="text.secondary">{label}</Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
